import React, { useState } from "react";
import Classes from "./Profile.module.css";

const EditIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 512 512"><path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1 0 32c0 8.8 7.2 16 16 16l32 0zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" /></svg>
)

const ProfileCard = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [profile, setProfile] = useState({
        firstName: "John",
        lastName: "Smith",
        email: "johnsmith@email.com",
        phone: "(111) 111-1111",
        password: "xxxxxxxxxxxx",
        bio: "Website Designer",
        image: "/assets/images/profile.png", // Placeholder image
    });

    const placeholders = {
        firstName: "John",
        lastName: "Smith",
        email: "johnsmith@email.com",
        phone: "(111) 111-1111",
        password: "xxxxxxxxxxxx",
        bio: "Website Designer",
    }

    const handleInputChange = (e) => {
        setProfile({ ...profile, [e.target.name]: e.target.value });
    };

    const toggleEdit = () => {
        setIsEditing(!isEditing);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setProfile({ ...profile, image: reader.result });
            };
            reader.readAsDataURL(file);
        }
    };

    return (
        <div className={Classes.container}>
            {/* Profile Header */}
            <div className={Classes.profileHeader}>
                <label htmlFor="profileImage" className={Classes.card_img} >
                    <img src={profile.image} className={Classes.card_inner_img} />
                    <img src='/assets/icons/camera.png' style={{ position: 'relative', height: '1.2rem' }} />
                </label>
                <input
                    type="file"
                    id="profileImage"
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                />
                <span className={Classes.userInfo}>{profile.firstName} {profile.lastName}</span>
            </div>

            {/* Personal Information Section */}
            <div className={Classes.infoSection}>
                <div className={Classes.box2Header} >
                    <h3>Personal information</h3>
                    <button className={Classes.editButton} onClick={toggleEdit}>
                        {isEditing ?
                            <>
                                Save
                            </>
                            :
                            <>
                                <EditIcon height='12px' fill='#969696' />
                                Edit
                            </>
                        }
                    </button>
                </div>

                <div className={Classes.infoGrid}>
                    {["firstName", "lastName", "email", "phone", "password", "bio"].map(
                        (field) => (
                            <div key={field}>
                                <label className={Classes.label}> <h5> {field.replace(/([A-Z])/g, " $1")} </h5> </label>
                                {isEditing ? (
                                    <input
                                        type={field === "password" ? "password" : "text"}
                                        name={field}
                                        value={profile[field]}
                                        onChange={handleInputChange}
                                        className={Classes.inputField}
                                        placeholder={placeholders[field]}
                                    />
                                ) : (
                                    <p className={Classes.textValue}>{profile[field]}</p>
                                )}
                            </div>
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProfileCard;
